import { createRouter, createWebHistory } from 'vue-router';
import HomeDP from '@/views/homeDP/index.vue'; // 引入一个示例视图组件
import web from '@/views/homeDP/webSocketPage.vue';
import sbh from '@/views/homeDP/sbh.vue';
import sbh2 from '@/views/homeDP/sbh2.vue';
import sbh3 from '@/views/homeDP/sbh3.vue';
import xrj from '@/views/homeDP/xrj.vue';
import zw from '@/views/homeDP/zw.vue';
import nbl from '@/views/homeDP/nbl.vue';
import nbljt from '@/views/homeDP/nbljt.vue';
import redGold from '@/components/redGold.vue';



const routes = [
  {
    path: '/',
    name: 'web',
    component: web
  },
  {
    path: '/web',
    name: 'homeDP',
    component: HomeDP,
  },
 
  {
    path: '/sbh',
    name: 'sbh',
    component: sbh
  },
  
  {
    path: '/sbh2',
    name: 'sbh2',
    component: sbh2
  },
  {
    path: '/sbh3',
    name: 'sbh3',
    component: sbh3
  },
  {
    path: '/xrj',
    name: 'xrj',
    component: xrj
  },
  {
    path: '/zw',
    name: 'zw',
    component: zw
  },
  {
    path: '/nbl',
    name: 'nbl',
    component: nbl
  },
  {
    path: '/nbljt',
    name: 'nbljt',
    component: nbljt
  },
  {
    path: '/redGold',
    name: 'redGold',
    component: redGold
  }
  // 其他路由配置
];

const router = createRouter({
  // history: createWebHistory('/metalMarketTest/'), // ← 这里必须设置
  history: createWebHistory(),
  routes,
});

export default router;